import { useState, useEffect, useRef } from 'react';
import contArrow from "../assets/images/contArrow.png"
import contArrowblack from "../assets/images/contArrowblack.png"
import search from "../assets/images/search.png"
import logo from "../assets/images/logo.png"
import closebtn from "../assets/images/closebtn.png"
import navbar from "../assets/images/navmob.svg"
import playblack from "../assets/images/playblack.png"
import playwhite from "../assets/images/playwhite.png"
import inputsearch from "../assets/images/inputsearch.svg"
import inputclose from "../assets/images/inputclose.svg"
import { Link } from "react-router-dom";
import comingsoon from "../assets/images/comingsoon.svg"
import { scrollToSection } from "../utils/scrollHelpers";
const Header = ({ gamesData = {} }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [gameNames, setGameNames] = useState([]);
  const [activeSection, setActiveSection] = useState('home');
  const [active, setActive] = useState(false);
  const searchInputRef = useRef(null);

  const [categories, setCategories] = useState([
    { id: "3", gametype: "Live Games" },
    { id: "4", gametype: "Casino Games" },
    { id: "2", gametype: "Card Games" },
    { id: "1", gametype: "Table & Board Games" }
  ]);

  const getCategoryName = (gameType) => {
    const idStr = String(gameType);
    const found = categories.find((c) => String(c.id) === idStr);
    return found ? found.gametype : "Unknown";
  };

  useEffect(() => {
    // Store complete game data instead of just names
    if (gamesData?.data && Array.isArray(gamesData.data)) {
      setGameNames(gamesData.data);
    }
    if (gamesData?.game_category) {
      setCategories(gamesData.game_category);
    }
  }, [gamesData]);

  // Listen for close events from PageScripts
  useEffect(() => {
    const handleClearSearchFromPanel = () => {
      setSearchQuery('');
    };

    // Add custom event listener
    window.addEventListener('clearSearchInput', handleClearSearchFromPanel);

    return () => {
      window.removeEventListener('clearSearchInput', handleClearSearchFromPanel);
    };
  }, []);

  // Sync active state with DOM changes from PageScripts
  useEffect(() => {
    const expendcontDIV = document.querySelector('.expendcontDIV');
    if (!expendcontDIV) return;

    const observer = new MutationObserver(() => {
      const isOpen = expendcontDIV.classList.contains('open');
      setActive(isOpen);
    });

    observer.observe(expendcontDIV, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);

  // Add scroll listener for active section detection
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'games', 'about', 'contact'];
      const scrollPosition = window.scrollY;

      for (const sectionId of sections) {
        const section = document.getElementById(sectionId);
        if (section) {
          const top = section.offsetTop - 120;
          const bottom = top + section.offsetHeight;

          if (scrollPosition >= top && scrollPosition <= bottom) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call once on mount

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Filter games based on search query
  const filteredGames = gameNames.filter(game =>
    game.gamename?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    game.titlename?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSearchClick = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClearSearch = (e) => {
    e.stopPropagation(); // Prevent event from bubbling
    setSearchQuery('');
    // Keep focus on input after clearing
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  const handleMobileMenuClick = (e, sectionId) => {
    e.preventDefault(); // Prevent default anchor behavior

    // Close mobile nav dropdown
    const expendcontDIV = document.querySelector('.expendcontDIV');
    if (expendcontDIV?.classList.contains('open')) {
      expendcontDIV.classList.remove('open');
      setActive(false);
    }

    // Scroll to section after a small delay to ensure menu closes smoothly
    setTimeout(() => {
      scrollToSection(sectionId);
    }, 100);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const toggle = () => {
    const expendcontDIV = document.querySelector('.expendcontDIV');
    const isCurrentlyOpen = expendcontDIV?.classList.contains('open');

    // Close search panel if open
    if (isSearchOpen) {
      setIsSearchOpen(false);
      const searchPanel = document.querySelector('.expendsearch');
      searchPanel?.classList.remove('open');
    }

    // Toggle mobile nav
    if (isCurrentlyOpen) {
      expendcontDIV.classList.remove('open');
      setActive(false);
    } else {
      expendcontDIV.classList.add('open');
      setActive(true);
    }
  };
  return (
    <header className="header">
      <div className="container cusHeadCont">
        <div className="row cusHead">
          <div className="col-md-6 cusHeadBg">
            <div className="de-flex sm-pt10 headconT">
              <div className="de-flex-col">
                <div className="de-flex-col logohead">
                  <div id="logo">

                    <div className="GRIDbutton-wrapper">

                      <button
                        type="button"
                        className={`GRIDbutton ${active ? "active" : ""}`}
                        onClick={toggle}
                        aria-pressed={active}

                      >
                        <span className="iconmenu" aria-hidden="true" >
                          <div className="NAV chil1"></div>
                          <div className="NAV chil2"></div>
                          <div className="NAV chil3"></div>
                          <div className="NAV chil4"></div>

                        </span>
                      </button>

                    </div>

                    <a  onClick={() => scrollToSection("home")}>
                      <img
                        className="logo-main"
                        src={logo}
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="de-flex-col header-col-mid desK">
                <ul id="mainmenu">
                  <li>
                    <a
                      className={`menu-item ${activeSection === 'home' ? 'active' : ''}`}
                      onClick={() => scrollToSection("home")}
                      style={{ cursor: 'pointer' }}
                    >
                      Home
                    </a>
                  </li>

                  <li>
                    <a
                      className={`menu-item ${activeSection === 'games' ? 'active' : ''}`}
                      onClick={() => scrollToSection("games")}
                      style={{ cursor: 'pointer' }}
                    >
                      Games
                    </a>
                  </li>

                  <li>
                    <a
                      className={`menu-item ${activeSection === 'about' ? 'active' : ''}`}
                      onClick={() => scrollToSection("about")}
                      style={{ cursor: 'pointer' }}
                    >
                      About Us
                    </a>
                  </li>
                </ul>
              </div>
              <div className="de-flex-col">
                <div className="menu_side_area">
                  <div className="review-container_main contuS">
                    <img
                      src={search}
                      alt=""
                      className={`searchimg ${isSearchOpen ? 'd-none' : ''}`}
                      onClick={handleSearchClick}
                      style={{ cursor: 'pointer' }}
                    />
                    <img
                      src={closebtn}
                      alt=""
                      className={`closeimg ${isSearchOpen ? '' : 'd-none'}`}
                      onClick={handleSearchClick}
                      style={{ cursor: 'pointer' }}
                    />

                    <a
                      className="CommonbtN"
                      onClick={() => scrollToSection("contact")}
                      style={{ textDecoration: "none", cursor: "pointer" }}
                    >
                      <button className="SPA_button ContBTn">
                        <div className="button-content">
                          <div className="icon-wrapper">
                            <img
                              src={contArrow}
                              alt=""
                              className="contArrowHader"
                            />
                          </div>
                          <span>Contact Us</span>
                        </div>
                        <div className="hover-content">
                          <div className="icon-wrapper">
                            <img
                              src={contArrowblack}
                              alt=""
                              className="contArrow blacK"
                            />
                          </div>
                          <span>Contact Us</span>
                        </div>
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="expendsearch">
              <div className="searchBOX">
                <img src={inputsearch} alt="" className='inputsearch' />
                <input
                  ref={searchInputRef}
                  type="text"
                  className="searchbox"
                  placeholder="Search games..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
                {searchQuery && (
                  <img
                    src={inputclose}
                    alt=""
                    className='inputclose'
                    onClick={handleClearSearch}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </div>

              {searchQuery && (
                <div className="searchconatiner" data-lenis-prevent>
                  {filteredGames.length > 0 ? (
                    filteredGames.map((game, index) => (

                      <Link
                        to={game.status === 2 ? "#" : `/games/${encodeURIComponent(game.gamename)}`}
                        className={`${game.status === 2 ? "disableCursor" : ""}`}
                      >
                        <div className="searchconatiner_chind">
                          <div className="search_chind2">

                            <div className={`de-item s2 HEad desk ${game.status === 2 ? "comingsoonhover" : ""}`}>
                            <div className={`parenteBOx ${game.status === 2 ? "comingsoonActive" : ""}`}>


                            {game.status === 2 && (
                              <img src={comingsoon} className="comingsoon" alt="Coming Soon" />
                            )}

                            <img
                              className="NEWTAB_img"
                              src={game.image}
                              alt={game.gamename}
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                              }}
                            />

                            <button className="GameBTnNormal_HEAD">
                              <div className="button-content">
                                <div className="icon-wrapper">
                                  <img src={playwhite} alt="" className="PlaybuttonHover1" />
                                </div>
                              </div>
                            </button>
                          </div>

                          <div className="ChildBOx2">
                            <div className="tiTle2">
                              {game.titlename && game.titlename.length > 15
                                ? `${game.titlename.slice(0, 15)}...`
                                : game.titlename}
                            </div>
                            <div className="SubtiTle2">{getCategoryName(game.game_type)}</div>
                          </div>
                        </div>

                        <div className="de-item HEad mob">
                    
                                        <div className={`mobNavseach ${game.status === 2 ? "comingsoonActive" : ""}`}>
                               {game.status === 2 && (
                              <img src={comingsoon} className="comingsoonMob" alt="Coming Soon" />
                            )}
                            <img
                              className="mobIMG"
                              src={game.image}
                              alt={game.gamename}
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                              }}
                            />
                          </div>
                          <div className='mobNavseaChild'>
                            <div className="ChildBOx2">
                              <div className="tiTle2mob">
                                {game.titlename}
                              </div>
                              <div className="SubtiTle2">{getCategoryName(game.game_type)}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                        </div>
                      </Link>
            ))
            ) : (
            <div className="no-results">No games found</div>
                  )}
          </div>
              )}
        </div>

        <div className="expendcontDIV">
          <div className="conTEXT">
            <a
              className={`conmenu-item ${activeSection === 'home' ? 'active' : ''}`}
              href="#home"
              onClick={(e) => handleMobileMenuClick(e, 'home')}
            >
              Home
            </a>
          </div>
          <div className="conTEXT">
            <a
              className={`conmenu-item ${activeSection === 'games' ? 'active' : ''}`}
              href="#games"
              onClick={(e) => handleMobileMenuClick(e, 'games')}
            >
              Games
            </a>
          </div>
          <div className="conTEXT">
            <a
              className={`conmenu-item ${activeSection === 'about' ? 'active' : ''}`}
              href="#about"
              onClick={(e) => handleMobileMenuClick(e, 'about')}
            >
              About Us
            </a>
          </div>
          <div className="conTEXT">
            <a
              className={`conmenu-item ${activeSection === 'contact' ? 'active' : ''}`}
              href="#contact"
              onClick={(e) => handleMobileMenuClick(e, 'contact')}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
      </div >
    </header >
  );
};

export default Header;